function Avatar({ url, imageStyle }) {
  return (
    <img
      className={
        imageStyle
          ? imageStyle
          : "object-cover bg-gray-200 rounded-full shrink-0 w-7 h-7"
      }
      src={
        url ||
        "https://ckfwvufqcepsjlnnrzqi.supabase.co/storage/v1/object/public/company/logo-placeholder.png"
      }
      alt=""
    />
  );
}

export default Avatar;
